import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input"

export default class extends Controller {
  static targets = ["input", "hidden"]
  static values = {
    countryOrder: { type: Array, default: ["ch", "de", "at"] },
    initialCountry: { type: String, default: "ch" }
  }

  connect() {
    this.iti = intlTelInput(this.inputTarget, {
      loadUtils: () => import("intl-tel-input/utils"),
      countryOrder: this.countryOrderValue,
      initialCountry: this.initialCountryValue,
      separateDialCode: true
    })

    this.inputTarget.addEventListener("countrychange", () => {
      this.inputTarget.dispatchEvent(new Event("change"))
    })
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy()
    }
  }

  setNumber() {
    if (this.iti) {
      this.hiddenTarget.value = this.iti.getNumber()
    }
  }
}
